import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import HelpDialog from './HelpDialog';
import { closeDialog } from 'store/dialogs/actions';
import { getIsSmallScreen } from 'store/browser/selectors';

const mapStateToProps = createSelector(
  getIsSmallScreen,
  isSmallScreen => ({
    fullScreen: isSmallScreen
  })  
);

const actions = dispatch => ({
  onClose: () => dispatch(closeDialog())
});

export default connect(mapStateToProps, actions)(HelpDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/HelpDialog/index.js